import { Row as RowSkeleton } from "@circle-react-uikit/SkeletonLoader/components/Row";
import { toLocaleString } from "@circle-react/helpers/number";

import { t } from "@/i18n-js/instance";
import type { CSSAnchorAttributes } from "@/react/helpers/cssAnchorHelpers";

interface LikedByMessageProps {
  anchorProps?: CSSAnchorAttributes;
  isLoading: boolean;
  likesCount: number;
}

export const LikedByMessageV3 = ({
  anchorProps,
  likesCount,
  isLoading,
}: LikedByMessageProps) => {
  if (isLoading) {
    return <RowSkeleton lg extraLong />;
  }

  if (likesCount === 0) {
    return null;
  }

  return (
    <span
      className="overflow-anywhere text-default group-hover:text-dark text-sm font-medium"
      {...anchorProps}
    >
      {t("likes_count", {
        localeCount: toLocaleString(likesCount),
        count: likesCount,
      })}
    </span>
  );
};
